import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';


import CustomIframeComponent from './CustomIframeComponent';

const Iframe = Node.create({
  name: 'iframe',

  group: 'block',

  addOptions() {
    return {
      allowFullscreen: true,
      loading: 'lazy',
      referrerpolicy: 'no-referrer',
      HTMLAttributes: {
        class: 'iframe-wrapper',
      }
    };
  },

  addAttributes() {
    return {
      width: {
        default: '100%',
        renderHTML: (attributes) => {
          return {
            width: attributes.width
          };
        }
      },
      height: {
        default: '100%',
        renderHTML: (attributes) => {
          return {
            height: attributes.height
          };
        }
      },
      float: {
        default: 'none',
        rendered: false
      },
      aspectRatio: {
        default: null
      },
      style: {
        default: null,
      },
      src: {
        default: null,
      },
      frameborder: {
        default: 0,
      },
      loading: {
        default: this.options.loading,
        parseHTML: () => this.options.loading,
      },
      referrerpolicy: {
        defautl: this.options.referrerpolicy,
        parseHTML: () => this.options.referrerpolicy,
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen,
      },

    };
  },

  parseHTML() {
    return [{ tag: 'iframe' }];
  },

  renderHTML({ HTMLAttributes }) {

    const divElement = document.createElement('div');
    return divElement;
  },

  addNodeView() {
    return ReactNodeViewRenderer(CustomIframeComponent)
  },


  addCommands() {
    return {
      setIframe: (options) => ({ tr, dispatch }) => {
        const { selection } = tr;
        const node = this.type.create(options);

        if (dispatch) {
          tr.replaceRangeWith(selection.from, selection.to, node);
        }

        return true;
      },
    };
  },
});

export default Iframe;